
document.addEventListener('DOMContentLoaded',function(){
 const drawer=document.querySelector('[data-motion-drawer]');
 const back=document.querySelector('[data-motion-backdrop]');
 const open=document.querySelector('[data-motion-menu]');
 const close=document.querySelector('[data-motion-close]');
 function set(v){if(!drawer||!back)return;drawer.classList.toggle('open',v);back.classList.toggle('open',v);document.body.style.overflow=v?'hidden':''}
 if(open)open.addEventListener('click',()=>set(true));
 if(close)close.addEventListener('click',()=>set(false));
 if(back)back.addEventListener('click',()=>set(false));
 if(drawer)drawer.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>set(false)));
});
